import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CustomScrollingService {

  constructor(
    @Inject(PLATFORM_ID) public platformId: object
  ) {
  }

  public scrollToElementId(elementId: string, offset: number = 0) {
    if (isPlatformBrowser(this.platformId)) {
      const element: HTMLElement = document.getElementById(elementId);
      if (element) {
        this.scrollToElement(element, offset);
      }
    }
  }

  public scrollToElement(element: HTMLElement, offset: number = 0) {
    if (isPlatformBrowser(this.platformId)) {
      let yPosition: number = this.calculateYPosition(element) - offset;

      if (yPosition === 0) {
        yPosition = 0.1;
      }

      if (yPosition) {
        window.scrollTo({top: yPosition});
      }
    }
  }

  /**
   * Calculate the y position of an element.
   *
   * @param element to calculate the y position of.
   */
  calculateYPosition(element: HTMLElement) {
    let yPosition: number = 0;
    let e: HTMLElement = element;
    while (e) {
      yPosition += e.offsetTop;
      e = e.offsetParent as HTMLElement;
    }
    return yPosition;
  }

  /**
   * returns height of an element which is chosen by the selector.
   */
  calculateElementHeight(selector: string): number {
    if (isPlatformBrowser(this.platformId)) {
      const headerElement: HTMLElement = document.querySelector(selector);
      if (headerElement) {
        return headerElement.getBoundingClientRect().height;
      }
    }

    return 0;
  }

  scrollTop() {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}
